type e = "blur" | "change" | "focus" | "escape" | "ready";

import {
  loadStripe,
  Stripe,
  StripeConstructorOptions
} from "@stripe/stripe-js";

export let stripe: Stripe;
export const load = async (
  publishableKey: string,
  options: StripeConstructorOptions
) => {
  stripe = await loadStripe(publishableKey, options);
};

export const createPaymentRequestButton = (
  callback: Function,
  onPaymentMethod: Function
) => {
  const paymentRequest = stripe.paymentRequest({
    country: "AU",
    currency: "aud",
    total: {
      label: "Demo total",
      amount: 20000
    },
    requestPayerName: true,
    requestPayerEmail: true
  });
  const elements = stripe.elements();

  const button = elements.create("paymentRequestButton", {
    paymentRequest
  });
  (async () => {
    const result = await paymentRequest.canMakePayment();
    console.log(result);

    callback(result, button);
  })();
  paymentRequest.on("paymentmethod", async ev => {
    onPaymentMethod(ev);
  });
};
